import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import { getApiUrl } from '../config/api';
import './GestionProducto.css';

function SNRemision({ usuario }) {
    const [remisiones, setRemisiones] = useState([]);
    const [remisionesFiltradas, setRemisionesFiltradas] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);

    // Catalogos
    const [productos, setProductos] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [frangosDisponibles, setFrangosDisponibles] = useState([]);
    const [motivos, setMotivos] = useState([]);
    const [depositos, setDepositos] = useState([]);

    // Formulario cabecera
    const [formulario, setFormulario] = useState({
        idSucursal: '',
        boca: '',
        nremision: 0,
        fecha: '',
        fechafin: '',
        idDeposito: '',
        idCliente: '',
        nomCliente: '',
        idObra: 0,
        rucCliente: '',
        telCliente: '',
        dirPartida: '',
        dirLlegada: '',
        marcaVehiculo: '',
        chapa: '',
        nomTransportista: '',
        rucTransportista: '',
        nomConductor: '',
        ciConductor: '',
        idMotivo: '',
        otroMotivo: '',
        obs: '',
        tipoDoc: 'REM',
        vta: '0',
        estado: ' ',
        timbrado: '',
        telefono: ''
    });

    // Detalles
    const [detalles, setDetalles] = useState([]);
    const [detalleTemp, setDetalleTemp] = useState({
        idProducto: '',
        cantidad: 0,
        precio: 0,
        herr: 'N',
        funciona: 'N',
        numero: 0
    });

    // Confirmacion anular
    const [mostrarConfirmacionAnular, setMostrarConfirmacionAnular] = useState(false);
    const [remisionAAnular, setRemisionAAnular] = useState(null);

    // Ver remision
    const [modalVerAbierto, setModalVerAbierto] = useState(false);
    const [remisionVer, setRemisionVer] = useState(null);

    // Dropdown sucursal
    const [dropdownSucursalAbierto, setDropdownSucursalAbierto] = useState(false);
    const [busquedaSucursal, setBusquedaSucursal] = useState('');
    const dropdownSucursalRef = useRef(null);

    // Dropdown boca
    const [dropdownBocaAbierto, setDropdownBocaAbierto] = useState(false);
    const [busquedaBoca, setBusquedaBoca] = useState('');
    const dropdownBocaRef = useRef(null);

    // Dropdown timbrado
    const [dropdownTimbradoAbierto, setDropdownTimbradoAbierto] = useState(false);
    const [busquedaTimbrado, setBusquedaTimbrado] = useState('');
    const dropdownTimbradoRef = useRef(null);

    // Dropdown producto
    const [dropdownProductoAbierto, setDropdownProductoAbierto] = useState(false);
    const [busquedaProducto, setBusquedaProducto] = useState('');
    const dropdownProductoRef = useRef(null);

    // Dropdown cliente
    const [dropdownClienteAbierto, setDropdownClienteAbierto] = useState(false);
    const [busquedaCliente, setBusquedaCliente] = useState('');
    const dropdownClienteRef = useRef(null);

    // Dropdown motivo
    const [dropdownMotivoAbierto, setDropdownMotivoAbierto] = useState(false);
    const [busquedaMotivo, setBusquedaMotivo] = useState('');
    const dropdownMotivoRef = useRef(null);

    // Ordenamiento
    const [columnaOrden, setColumnaOrden] = useState('nremision');
    const [direccionOrden, setDireccionOrden] = useState('desc');

    // Selector de columnas
    const [selectorColumnasAbierto, setSelectorColumnasAbierto] = useState(false);
    const selectorColumnasRef = useRef(null);

    const todasLasColumnas = [
        { key: 'nremision', label: 'N° Remision', visible: true, fixed: true },
        { key: 'sucursal', label: 'Sucursal', visible: true },
        { key: 'boca', label: 'Boca', visible: true },
        { key: 'fecha', label: 'Fecha', visible: true },
        { key: 'nomCliente', label: 'Cliente', visible: true, fixed: true },
        { key: 'rucCliente', label: 'RUC', visible: true },
        { key: 'idMotivo', label: 'Motivo', visible: true },
        { key: 'timbrado', label: 'Timbrado', visible: true },
        { key: 'items', label: 'Items', visible: true },
        { key: 'dirPartida', label: 'Dir. Partida', visible: false },
        { key: 'dirLlegada', label: 'Dir. Llegada', visible: false },
        { key: 'marcaVehiculo', label: 'Marca Vehiculo', visible: false },
        { key: 'chapa', label: 'Chapa', visible: false },
        { key: 'nomTransportista', label: 'Transportista', visible: false },
        { key: 'rucTransportista', label: 'RUC Transp.', visible: false },
        { key: 'nomConductor', label: 'Conductor', visible: false },
        { key: 'ciConductor', label: 'CI Conductor', visible: false },
        { key: 'obs', label: 'Observaciones', visible: false },
        { key: 'estado', label: 'Estado', visible: false },
        { key: 'acciones', label: 'Acciones', visible: true, fixed: true }
    ];

    const [columnasVisibles, setColumnasVisibles] = useState(() => {
        const guardadas = localStorage.getItem('columnasRemisiones_v2');
        if (guardadas) return JSON.parse(guardadas);
        return todasLasColumnas;
    });

    // Paginacion
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    useEffect(() => {
        cargarRemisiones();
        cargarProductos();
        cargarClientes();
        cargarSucursales();
        cargarMotivos();
        cargarDepositos();
    }, []);

    useEffect(() => {
        filtrarRemisiones();
    }, [busqueda, remisiones]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownProductoRef.current && !dropdownProductoRef.current.contains(event.target)) {
                setDropdownProductoAbierto(false);
            }
            if (dropdownClienteRef.current && !dropdownClienteRef.current.contains(event.target)) {
                setDropdownClienteAbierto(false);
            }
            if (dropdownSucursalRef.current && !dropdownSucursalRef.current.contains(event.target)) {
                setDropdownSucursalAbierto(false);
            }
            if (dropdownBocaRef.current && !dropdownBocaRef.current.contains(event.target)) {
                setDropdownBocaAbierto(false);
            }
            if (dropdownTimbradoRef.current && !dropdownTimbradoRef.current.contains(event.target)) {
                setDropdownTimbradoAbierto(false);
            }
            if (dropdownMotivoRef.current && !dropdownMotivoRef.current.contains(event.target)) {
                setDropdownMotivoAbierto(false);
            }
            if (selectorColumnasRef.current && !selectorColumnasRef.current.contains(event.target)) {
                setSelectorColumnasAbierto(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        localStorage.setItem('columnasRemisiones_v2', JSON.stringify(columnasVisibles));
    }, [columnasVisibles]);

    const cargarRemisiones = async () => {
        try {
            const response = await axios.get(getApiUrl('/api/remisiones'));
            setRemisiones(response.data);
            setRemisionesFiltradas(response.data);
        } catch (error) {
            console.error('Error al cargar remisiones:', error);
            toast.error('Error al cargar las remisiones');
        }
    };

    const cargarProductos = async () => {
        try {
            const response = await axios.get(getApiUrl('/api/productos'));
            setProductos(response.data);
        } catch (error) {
            console.error('Error al cargar productos:', error);
        }
    };

    const cargarClientes = async () => {
        try {
            const response = await axios.get(getApiUrl('/api/clientes'));
            setClientes(response.data);
        } catch (error) {
            console.error('Error al cargar clientes:', error);
        }
    };

    const cargarSucursales = async () => {
        try {
            const response = await axios.get(getApiUrl('/api/sucursales'));
            setSucursales(response.data);
        } catch (error) {
            console.error('Error al cargar sucursales:', error);
        }
    };

    const cargarMotivos = async () => {
        try {
            const response = await axios.get(getApiUrl('/api/motivotrans'));
            setMotivos(response.data);
        } catch (error) {
            console.error('Error al cargar motivos:', error);
        }
    };

    const cargarDepositos = async () => {
        try {
            const response = await axios.get(getApiUrl('/api/depositos'));
            setDepositos(response.data);
        } catch (error) {
            console.error('Error al cargar depositos:', error);
        }
    };

    const cargarFrangosRemision = async (idSucursal, fecha) => {
        if (!idSucursal || !fecha) {
            setFrangosDisponibles([]);
            return;
        }
        try {
            const response = await axios.get(getApiUrl(`/api/frangos/remision/${idSucursal}?fecha=${fecha}`));
            setFrangosDisponibles(response.data);
            if (response.data.length === 0) {
                toast.warning('No hay rangos de remision activos para esta sucursal y fecha');
            }
        } catch (error) {
            console.error('Error al cargar frangos:', error);
            setFrangosDisponibles([]);
        }
    };

    const filtrarRemisiones = () => {
        if (!busqueda) {
            setRemisionesFiltradas(remisiones);
            setPaginaActual(1);
            return;
        }
        const filtradas = remisiones.filter(rem =>
            rem.nremision?.toString().includes(busqueda) ||
            rem.nomCliente?.toLowerCase().includes(busqueda.toLowerCase()) ||
            rem.nfactura?.toString().includes(busqueda) ||
            rem.obs?.toLowerCase().includes(busqueda.toLowerCase())
        );
        setRemisionesFiltradas(filtradas);
        setPaginaActual(1);
    };

    // Selector de columnas
    const toggleColumna = (key) => {
        setColumnasVisibles(prev =>
            prev.map(col => col.key === key && !col.fixed ? { ...col, visible: !col.visible } : col)
        );
    };

    const mostrarTodasColumnas = () => {
        setColumnasVisibles(prev => prev.map(col => ({ ...col, visible: true })));
    };

    const ocultarTodasColumnas = () => {
        setColumnasVisibles(prev => prev.map(col => col.fixed ? col : { ...col, visible: false }));
    };

    const restaurarColumnasDefecto = () => {
        setColumnasVisibles(todasLasColumnas);
        localStorage.removeItem('columnasRemisiones');
    };

    const obtenerValorColumna = (rem, key) => {
        switch (key) {
            case 'nremision': return rem.nremision;
            case 'sucursal': return obtenerNombreSucursal(rem.idSucursal);
            case 'boca': return rem.boca;
            case 'fecha': return formatearFechaDisplay(rem.fecha);
            case 'nomCliente': return rem.nomCliente;
            case 'rucCliente': return rem.rucCliente;
            case 'idMotivo': return obtenerNombreMotivo(rem.idMotivo);
            case 'timbrado': return rem.timbrado;
            case 'items': return rem.detalles?.length || 0;
            case 'estado': return rem.estado === 'A' ? 'Anulada' : 'Activa';
            default: return rem[key] || '';
        }
    };

    // Ordenamiento
    const toggleOrden = (columna) => {
        if (columnaOrden === columna) {
            setDireccionOrden(prev => prev === 'asc' ? 'desc' : 'asc');
        } else {
            setColumnaOrden(columna);
            setDireccionOrden('asc');
        }
        setPaginaActual(1);
    };

    const indicadorOrden = (columna) => {
        if (columnaOrden !== columna) return ' ↕';
        return direccionOrden === 'asc' ? ' ▲' : ' ▼';
    };

    const remisionesOrdenadas = useMemo(() => {
        const datos = [...remisionesFiltradas];
        datos.sort((a, b) => {
            let valA, valB;
            switch (columnaOrden) {
                case 'nremision':
                    valA = a.nremision || 0;
                    valB = b.nremision || 0;
                    break;
                case 'sucursal':
                    valA = obtenerNombreSucursal(a.idSucursal)?.toString().toLowerCase() || '';
                    valB = obtenerNombreSucursal(b.idSucursal)?.toString().toLowerCase() || '';
                    break;
                case 'boca':
                    valA = a.boca || 0;
                    valB = b.boca || 0;
                    break;
                case 'fecha':
                    valA = a.fecha || '';
                    valB = b.fecha || '';
                    break;
                case 'nomCliente':
                    valA = (a.nomCliente || '').toLowerCase();
                    valB = (b.nomCliente || '').toLowerCase();
                    break;
                case 'rucCliente':
                    valA = (a.rucCliente || '').toLowerCase();
                    valB = (b.rucCliente || '').toLowerCase();
                    break;
                case 'idMotivo':
                    valA = obtenerNombreMotivo(a.idMotivo)?.toLowerCase() || '';
                    valB = obtenerNombreMotivo(b.idMotivo)?.toLowerCase() || '';
                    break;
                case 'timbrado':
                    valA = (a.timbrado || '').toLowerCase();
                    valB = (b.timbrado || '').toLowerCase();
                    break;
                case 'items':
                    valA = a.detalles?.length || 0;
                    valB = b.detalles?.length || 0;
                    break;
                default:
                    valA = a.nremision || 0;
                    valB = b.nremision || 0;
            }
            if (valA < valB) return direccionOrden === 'asc' ? -1 : 1;
            if (valA > valB) return direccionOrden === 'asc' ? 1 : -1;
            return 0;
        });
        return datos;
    }, [remisionesFiltradas, columnaOrden, direccionOrden, sucursales, motivos]);

    // Paginacion
    const indexUltimoItem = paginaActual * itemsPorPagina;
    const indexPrimerItem = indexUltimoItem - itemsPorPagina;
    const itemsActuales = remisionesOrdenadas.slice(indexPrimerItem, indexUltimoItem);
    const totalPaginas = Math.ceil(remisionesOrdenadas.length / itemsPorPagina);

    const formatearFechaDisplay = (fecha) => {
        if (!fecha) return '';
        const [year, month, day] = fecha.split('-');
        return `${day}/${month}/${year}`;
    };

    const formatearNumero = (valor, decimales = 2) => {
        if (!valor && valor !== 0) return '';
        const numero = parseFloat(valor);
        return numero.toLocaleString(undefined, {
            minimumFractionDigits: decimales,
            maximumFractionDigits: decimales
        });
    };

    const obtenerDescripcionProducto = (idProducto) => {
        const producto = productos.find(p => p.idProducto?.toString() === idProducto?.toString());
        return producto ? producto.descripcion : '';
    };

    const obtenerNombreSucursal = (idSucursal) => {
        const sucursal = sucursales.find(s => s.idSucursal === parseInt(idSucursal));
        return sucursal ? sucursal.nombre : idSucursal;
    };

    // Bocas disponibles derivadas de frangos
    const bocasDisponibles = useMemo(() => {
        const bocasMap = {};
        frangosDisponibles.forEach(f => {
            if (!bocasMap[f.boca]) {
                bocasMap[f.boca] = { boca: f.boca, cantTimbrados: 0 };
            }
            bocasMap[f.boca].cantTimbrados++;
        });
        return Object.values(bocasMap).sort((a, b) => a.boca - b.boca);
    }, [frangosDisponibles]);

    // Depositos de la sucursal seleccionada (activos)
    const depositosFiltrados = useMemo(() => {
        if (!formulario.idSucursal) return [];
        return depositos.filter(d => Number(d.idSucursal) === Number(formulario.idSucursal)
            && (d.estado === undefined || d.estado === null || d.estado === 'A'));
    }, [depositos, formulario.idSucursal]);

    // Timbrados disponibles para la boca seleccionada
    const timbradosDisponibles = useMemo(() => {
        if (!formulario.boca) return [];
        return frangosDisponibles.filter(f => f.boca === parseInt(formulario.boca));
    }, [frangosDisponibles, formulario.boca]);

    // Selector de sucursal
    const filtrarSucursales = (busq) => {
        if (!busq) return sucursales;
        const busqLower = busq.toLowerCase();
        return sucursales.filter(s =>
            s.idSucursal?.toString().includes(busqLower) ||
            s.nombre?.toLowerCase().includes(busqLower)
        );
    };

    const seleccionarSucursal = (sucursal) => {
        setFormulario(prev => ({ ...prev, idSucursal: sucursal.idSucursal, boca: '', timbrado: '', idDeposito: '' }));
        setDropdownSucursalAbierto(false);
        setBusquedaSucursal('');
        // Cargar frangos si ya hay fecha
        if (formulario.fecha) {
            cargarFrangosRemision(sucursal.idSucursal, formulario.fecha);
        }
    };

    const limpiarSucursal = () => {
        setFormulario(prev => ({ ...prev, idSucursal: '', boca: '', timbrado: '', idDeposito: '' }));
        setBusquedaSucursal('');
        setFrangosDisponibles([]);
    };

    // Selector de boca
    const filtrarBocas = (busq) => {
        if (!busq) return bocasDisponibles;
        return bocasDisponibles.filter(b => b.boca.toString().includes(busq));
    };

    const seleccionarBoca = (bocaItem) => {
        setFormulario(prev => ({ ...prev, boca: bocaItem.boca, timbrado: '' }));
        setDropdownBocaAbierto(false);
        setBusquedaBoca('');
        // Si solo hay un timbrado para esta boca, seleccionarlo automaticamente
        const timbrados = frangosDisponibles.filter(f => f.boca === bocaItem.boca);
        if (timbrados.length === 1) {
            setFormulario(prev => ({ ...prev, boca: bocaItem.boca, timbrado: timbrados[0].timbrado }));
        }
    };

    const limpiarBoca = () => {
        setFormulario(prev => ({ ...prev, boca: '', timbrado: '' }));
        setBusquedaBoca('');
    };

    // Selector de timbrado
    const filtrarTimbrados = (busq) => {
        if (!busq) return timbradosDisponibles;
        const busqLower = busq.toLowerCase();
        return timbradosDisponibles.filter(f =>
            f.timbrado?.toLowerCase().includes(busqLower)
        );
    };

    const seleccionarTimbrado = (frango) => {
        setFormulario(prev => ({ ...prev, timbrado: frango.timbrado }));
        setDropdownTimbradoAbierto(false);
        setBusquedaTimbrado('');
    };

    const limpiarTimbrado = () => {
        setFormulario(prev => ({ ...prev, timbrado: '' }));
        setBusquedaTimbrado('');
    };

    // Selector de motivo
    const filtrarMotivos = (busq) => {
        if (!busq) return motivos;
        const busqLower = busq.toLowerCase();
        return motivos.filter(m =>
            m.idMotivo?.toLowerCase().includes(busqLower) ||
            m.nomMotivo?.toLowerCase().includes(busqLower)
        );
    };

    const seleccionarMotivo = (motivo) => {
        setFormulario(prev => ({ ...prev, idMotivo: motivo.idMotivo }));
        setDropdownMotivoAbierto(false);
        setBusquedaMotivo('');
    };

    const limpiarMotivo = () => {
        setFormulario(prev => ({ ...prev, idMotivo: '' }));
        setBusquedaMotivo('');
    };

    const obtenerNombreMotivo = (idMotivo) => {
        const motivo = motivos.find(m => m.idMotivo === idMotivo);
        return motivo ? motivo.nomMotivo : idMotivo;
    };

    // Selector de producto
    const filtrarProductos = (busq) => {
        if (!busq) return productos.slice(0, 50);
        const busqLower = busq.toLowerCase();
        return productos.filter(p =>
            p.idProducto?.toString().includes(busqLower) ||
            p.descripcion?.toLowerCase().includes(busqLower)
        ).slice(0, 50);
    };

    const seleccionarProducto = (producto) => {
        setDetalleTemp(prev => ({
            ...prev,
            idProducto: producto.idProducto.toString(),
            precio: producto.precio1 || 0
        }));
        setDropdownProductoAbierto(false);
        setBusquedaProducto('');
    };

    const limpiarProducto = () => {
        setDetalleTemp(prev => ({ ...prev, idProducto: '', precio: 0 }));
        setBusquedaProducto('');
    };

    // Selector de cliente
    const filtrarClientes = (busq) => {
        if (!busq) return clientes.slice(0, 50);
        const busqLower = busq.toLowerCase();
        return clientes.filter(c =>
            c.idCliente?.toString().includes(busqLower) ||
            c.nomCliente?.toLowerCase().includes(busqLower) ||
            c.rucCliente?.toLowerCase().includes(busqLower)
        ).slice(0, 50);
    };

    const seleccionarCliente = (cliente) => {
        setFormulario(prev => ({
            ...prev,
            idCliente: cliente.idCliente,
            nomCliente: cliente.nomCliente || '',
            rucCliente: cliente.rucCliente || '',
            telCliente: cliente.telefono || '',
            dirLlegada: cliente.direccion || ''
        }));
        setDropdownClienteAbierto(false);
        setBusquedaCliente('');
    };

    const limpiarCliente = () => {
        setFormulario(prev => ({
            ...prev, idCliente: '', nomCliente: '', rucCliente: '', telCliente: ''
        }));
        setBusquedaCliente('');
    };

    const handleChangeFormulario = (e) => {
        const { name, value } = e.target;
        setFormulario(prev => ({ ...prev, [name]: value }));

        // Si cambia la fecha y hay sucursal, recargar frangos
        if (name === 'fecha' && formulario.idSucursal && value) {
            cargarFrangosRemision(formulario.idSucursal, value);
            // Limpiar boca y timbrado porque los rangos pueden cambiar
            setFormulario(prev => ({ ...prev, [name]: value, boca: '', timbrado: '' }));
        }
    };

    const handleChangeDetalleTemp = (e) => {
        const { name, value } = e.target;
        setDetalleTemp(prev => ({ ...prev, [name]: value }));
    };

    const agregarDetalle = () => {
        if (!detalleTemp.idProducto) {
            toast.warning('Debe seleccionar un producto');
            return;
        }
        if (parseFloat(detalleTemp.cantidad) <= 0) {
            toast.warning('La cantidad debe ser mayor a 0');
            return;
        }
        const existe = detalles.find(d => d.idProducto === detalleTemp.idProducto);
        if (existe) {
            toast.warning('Este producto ya esta en la lista');
            return;
        }

        setDetalles(prev => [...prev, { ...detalleTemp }]);
        setDetalleTemp({ idProducto: '', cantidad: 0, precio: 0, herr: 'N', funciona: 'N', numero: 0 });
        setBusquedaProducto('');
    };

    const eliminarDetalle = (idProducto) => {
        setDetalles(prev => prev.filter(d => d.idProducto !== idProducto));
    };

    const abrirModalNuevo = () => {
        const ahora = new Date();
        const hoy = `${ahora.getFullYear()}-${String(ahora.getMonth() + 1).padStart(2, '0')}-${String(ahora.getDate()).padStart(2, '0')}`;
        setFormulario({
            idSucursal: '', boca: '', nremision: 0, fecha: hoy, fechafin: '', idDeposito: '',
            idCliente: '', nomCliente: '', idObra: 0, rucCliente: '', telCliente: '',
            dirPartida: '', dirLlegada: '', marcaVehiculo: '', chapa: '',
            nomTransportista: '', rucTransportista: '', nomConductor: '', ciConductor: '',
            idMotivo: '', otroMotivo: '', obs: '', tipoDoc: 'REM',
            vta: '0', estado: ' ', timbrado: '', telefono: ''
        });
        setDetalles([]);
        setDetalleTemp({ idProducto: '', cantidad: 0, precio: 0, herr: 'N', funciona: 'N', numero: 0 });
        setFrangosDisponibles([]);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
        setDetalles([]);
        setDetalleTemp({ idProducto: '', cantidad: 0, precio: 0, herr: 'N', funciona: 'N', numero: 0 });
        setFrangosDisponibles([]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formulario.fecha) { toast.warning('La fecha es requerida'); return; }
        if (!formulario.idSucursal) { toast.warning('Debe seleccionar una sucursal'); return; }
        if (!formulario.boca) { toast.warning('Debe seleccionar una boca'); return; }
        if (!formulario.timbrado) { toast.warning('Debe seleccionar un timbrado'); return; }
        if (!formulario.idDeposito) { toast.warning('Debe seleccionar un deposito'); return; }
        if (!formulario.idCliente) { toast.warning('Debe seleccionar un cliente'); return; }
        if (detalles.length === 0) { toast.warning('Debe agregar al menos un detalle'); return; }

        const datosEnviar = {
            idSucursal: parseInt(formulario.idSucursal),
            boca: parseInt(formulario.boca),
            nremision: parseInt(formulario.nremision),
            fecha: formulario.fecha,
            fechafin: formulario.fechafin || null,
            idDeposito: parseInt(formulario.idDeposito),
            idCliente: parseInt(formulario.idCliente),
            nomCliente: formulario.nomCliente,
            idObra: parseInt(formulario.idObra) || null,
            rucCliente: formulario.rucCliente,
            telCliente: formulario.telCliente,
            dirPartida: formulario.dirPartida,
            dirLlegada: formulario.dirLlegada,
            marcaVehiculo: formulario.marcaVehiculo,
            chapa: formulario.chapa,
            nomTransportista: formulario.nomTransportista,
            rucTransportista: formulario.rucTransportista,
            nomConductor: formulario.nomConductor,
            ciConductor: formulario.ciConductor,
            idMotivo: formulario.idMotivo,
            otroMotivo: formulario.otroMotivo,
            obs: formulario.obs,
            tipoDoc: formulario.tipoDoc,
            vta: formulario.vta,
            estado: formulario.estado,
            timbrado: formulario.timbrado,
            telefono: formulario.telefono,
            detalles: detalles.map(d => ({
                idProducto: parseInt(d.idProducto),
                cantidad: parseFloat(d.cantidad),
                costoprom: 0,
                costoulcom: 0,
                idMedida: null,
                herr: d.herr,
                funciona: d.funciona,
                numero: parseInt(d.numero) || 0,
                precio: parseFloat(d.precio) || 0
            }))
        };

        try {
            await axios.post(getApiUrl('/api/remisiones'), datosEnviar);
            toast.success('Remision creada exitosamente');
            cargarRemisiones();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar remision:', error);
            toast.error('Error al guardar: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleAnular = (rem) => {
        if (rem.estado === 'A') {
            toast.warning('Esta remision ya se encuentra anulada');
            return;
        }
        setRemisionAAnular(rem);
        setMostrarConfirmacionAnular(true);
    };

    const verRemision = async (rem) => {
        // Cargar la remision completa con sus detalles desde el backend
        try {
            const r = await axios.get(getApiUrl(`/api/remisiones/${rem.idSucursal}/${rem.boca}/${rem.nremision}`));
            setRemisionVer(r.data);
        } catch (error) {
            console.error('Error al cargar remision:', error);
            // Fallback: usar los datos que ya estan en la grilla
            setRemisionVer(rem);
        }
        setModalVerAbierto(true);
    };

    const imprimirRemision = (rem) => {
        const params = new URLSearchParams({
            idSucursal: String(rem.idSucursal || ''),
            boca: String(rem.boca || ''),
            nremision: String(rem.nremision || ''),
            timbrado: rem.timbrado || ''
        });
        const url = getApiUrl('/api/remisiones/imprimir') + '?' + params.toString();
        window.open(url, '_blank');
    };

    const confirmarAnular = async () => {
        try {
            const rem = remisionAAnular;
            await axios.put(getApiUrl(`/api/remisiones/${rem.idSucursal}/${rem.boca}/${rem.nremision}/anular`));
            toast.success('Remision anulada exitosamente');
            cargarRemisiones();
        } catch (error) {
            console.error('Error al anular:', error);
            toast.error('Error al anular: ' + (error.response?.data?.message || error.message));
        } finally {
            setMostrarConfirmacionAnular(false);
            setRemisionAAnular(null);
        }
    };

    const exportarExcel = () => {
        const columnasParaExportar = columnasVisibles.filter(col => col.visible && col.key !== 'acciones');
        const datosExportar = remisionesOrdenadas.map(rem => {
            const fila = {};
            columnasParaExportar.forEach(col => {
                fila[col.label] = obtenerValorColumna(rem, col.key);
            });
            return fila;
        });
        const ws = XLSX.utils.json_to_sheet(datosExportar);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Remisiones');
        XLSX.writeFile(wb, 'remisiones.xlsx');
    };

    return (
        <div className="gestion-producto-container">
            <div className="header-seccion">
                <h2>Notas de Remision</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                        className="input-busqueda"
                    />
                    <button onClick={abrirModalNuevo} className="btn btn-nuevo">
                        + Nueva Remision
                    </button>
                    <div className="selector-columnas-wrapper" ref={selectorColumnasRef}>
                        <button
                            onClick={() => setSelectorColumnasAbierto(!selectorColumnasAbierto)}
                            className="btn btn-columnas"
                            title="Configurar columnas"
                        >
                            Columnas
                        </button>
                        {selectorColumnasAbierto && (
                            <div className="selector-columnas-dropdown">
                                <div className="selector-columnas-header">
                                    <h4>Configurar Columnas</h4>
                                    <button onClick={() => setSelectorColumnasAbierto(false)} className="btn-cerrar-selector">✖</button>
                                </div>
                                <div className="selector-columnas-acciones">
                                    <button onClick={mostrarTodasColumnas} className="btn-selector-mini">Todas</button>
                                    <button onClick={ocultarTodasColumnas} className="btn-selector-mini">Ninguna</button>
                                    <button onClick={restaurarColumnasDefecto} className="btn-selector-mini">Restaurar</button>
                                </div>
                                <div className="selector-columnas-lista">
                                    {columnasVisibles.map(columna => (
                                        <label key={columna.key} className={`selector-columna-item ${columna.fixed ? 'fija' : ''}`}>
                                            <input
                                                type="checkbox"
                                                checked={columna.visible}
                                                onChange={() => toggleColumna(columna.key)}
                                                disabled={columna.fixed}
                                            />
                                            <span>{columna.label}</span>
                                            {columna.fixed && <span className="badge-fija">Fija</span>}
                                        </label>
                                    ))}
                                </div>
                                <div className="selector-columnas-footer">
                                    <small>{columnasVisibles.filter(c => c.visible).length} de {columnasVisibles.length} columnas visibles</small>
                                </div>
                            </div>
                        )}
                    </div>
                    <button onClick={exportarExcel} className="btn btn-exportar">
                        Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            {columnasVisibles.filter(col => col.visible).map(columna => (
                                <th
                                    key={columna.key}
                                    style={columna.key !== 'acciones' ? { cursor: 'pointer' } : {}}
                                    onClick={() => columna.key !== 'acciones' && toggleOrden(columna.key)}
                                >
                                    {columna.label}
                                    {columna.key !== 'acciones' && indicadorOrden(columna.key)}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {itemsActuales.length === 0 ? (
                            <tr><td colSpan={columnasVisibles.filter(col => col.visible).length} className="sin-datos">No hay remisiones</td></tr>
                        ) : (
                            itemsActuales.map(rem => (
                                <tr key={`${rem.idSucursal}-${rem.boca}-${rem.nremision}`}>
                                    {columnasVisibles.filter(col => col.visible).map(columna => {
                                        if (columna.key === 'acciones') {
                                            return (
                                                <td key={columna.key}>
                                                    <button
                                                        onClick={() => verRemision(rem)}
                                                        className="btn-accion"
                                                        title="Ver remision"
                                                        style={{ marginRight: '5px' }}
                                                    >
                                                        Ver
                                                    </button>
                                                    <button
                                                        onClick={() => imprimirRemision(rem)}
                                                        className="btn-accion"
                                                        title="Imprimir remision (PDF)"
                                                        style={{ marginRight: '5px', color: '#2DCCD3' }}
                                                    >
                                                        🖨️
                                                    </button>
                                                    <button
                                                        onClick={() => handleAnular(rem)}
                                                        className="btn-accion"
                                                        title="Anular"
                                                        disabled={rem.estado === 'A'}
                                                        style={rem.estado === 'A' ? { opacity: 0.4, cursor: 'not-allowed' } : {}}
                                                    >
                                                        Anular
                                                    </button>
                                                </td>
                                            );
                                        }
                                        return (
                                            <td key={columna.key}>
                                                {obtenerValorColumna(rem, columna.key)}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Paginacion */}
            <div className="paginacion-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', borderTop: '1px solid #ddd' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <label>Mostrar:</label>
                    <select value={itemsPorPagina} onChange={(e) => { setItemsPorPagina(Number(e.target.value)); setPaginaActual(1); }} className="select-items">
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                    <span>por pagina</span>
                </div>
                <div>Mostrando {indexPrimerItem + 1} - {Math.min(indexUltimoItem, remisionesOrdenadas.length)} de {remisionesOrdenadas.length}</div>
                <div style={{ display: 'flex', gap: '5px' }}>
                    <button onClick={() => setPaginaActual(p => Math.max(1, p - 1))} disabled={paginaActual === 1} className="btn-paginacion">Anterior</button>
                    <button onClick={() => setPaginaActual(p => Math.min(totalPaginas, p + 1))} disabled={paginaActual === totalPaginas} className="btn-paginacion">Siguiente</button>
                </div>
            </div>

            {/* Modal confirmacion anular */}
            {mostrarConfirmacionAnular && (
                <div className="modal-overlay">
                    <div className="modal-contenido">
                        <div className="modal-header">
                            <h3>Confirmar anulacion</h3>
                            <button className="btn-cerrar" onClick={() => { setMostrarConfirmacionAnular(false); setRemisionAAnular(null); }}>×</button>
                        </div>
                        <div className="modal-body">
                            <p>¿Esta seguro de anular la remision <strong>N° {remisionAAnular?.nremision}</strong>?</p>
                            <p style={{ marginTop: '8px', color: '#dc3545', fontSize: '13px' }}>Esta accion no se puede deshacer.</p>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-cancelar" onClick={() => { setMostrarConfirmacionAnular(false); setRemisionAAnular(null); }}>Cancelar</button>
                            <button className="btn btn-guardar" onClick={confirmarAnular} style={{ backgroundColor: '#dc3545' }}>Anular</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal ver remision */}
            {modalVerAbierto && remisionVer && (
                <div className="modal-overlay">
                    <div className="modal-contenido-grande" style={{ maxWidth: '1000px' }}>
                        <div className="modal-header">
                            <h3>Remision N° {String(remisionVer.idSucursal).padStart(3,'0')}-{String(remisionVer.boca).padStart(3,'0')}-{remisionVer.nremision}</h3>
                            <button className="btn-cerrar" onClick={() => { setModalVerAbierto(false); setRemisionVer(null); }}>×</button>
                        </div>
                        <div className="modal-body">
                            {/* Cabecera */}
                            <div className="form-section">
                                <h3>Datos de Cabecera</h3>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px', fontSize: '13px' }}>
                                    <div><strong>Fecha:</strong> {remisionVer.fecha ? formatearFechaDisplay(remisionVer.fecha) : ''}</div>
                                    <div><strong>Fecha Fin:</strong> {remisionVer.fechafin ? formatearFechaDisplay(remisionVer.fechafin) : ''}</div>
                                    <div><strong>Timbrado:</strong> {remisionVer.timbrado}</div>
                                    <div><strong>Estado:</strong> {remisionVer.estado === 'A' ? 'Anulada' : 'Activa'}</div>
                                    <div><strong>Deposito:</strong> {(() => { const dep = depositos.find(d => Number(d.idDeposito) === Number(remisionVer.idDeposito)); return dep ? `${dep.idDeposito} - ${dep.nomDepto}` : (remisionVer.idDeposito || ''); })()}</div>
                                </div>
                            </div>

                            {/* Cliente */}
                            <div className="form-section" style={{ marginTop: '12px' }}>
                                <h3>Cliente</h3>
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '10px', fontSize: '13px' }}>
                                    <div><strong>Cliente:</strong> [{remisionVer.idCliente}] {remisionVer.nomCliente}</div>
                                    <div><strong>RUC:</strong> {remisionVer.rucCliente}</div>
                                    <div><strong>Telefono:</strong> {remisionVer.telCliente}</div>
                                </div>
                            </div>

                            {/* Transporte */}
                            <div className="form-section" style={{ marginTop: '12px' }}>
                                <h3>Transporte</h3>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '13px' }}>
                                    <div><strong>Dir. Partida:</strong> {remisionVer.dirPartida}</div>
                                    <div><strong>Dir. Llegada:</strong> {remisionVer.dirLlegada}</div>
                                    <div><strong>Transportista:</strong> {remisionVer.nomTransportista} {remisionVer.rucTransportista ? '(' + remisionVer.rucTransportista + ')' : ''}</div>
                                    <div><strong>Conductor:</strong> {remisionVer.nomConductor} {remisionVer.ciConductor ? '(CI: ' + remisionVer.ciConductor + ')' : ''}</div>
                                    <div><strong>Marca Vehiculo:</strong> {remisionVer.marcaVehiculo}</div>
                                    <div><strong>Chapa:</strong> {remisionVer.chapa}</div>
                                </div>
                            </div>

                            {remisionVer.obs && <div style={{ marginTop: '10px', fontSize: '13px' }}><strong>Obs:</strong> {remisionVer.obs}</div>}

                            {/* Detalle */}
                            <div className="form-section" style={{ marginTop: '12px' }}>
                                <h3>Detalle</h3>
                                <table className="tabla-datos" style={{ fontSize: '13px' }}>
                                    <thead><tr><th>Item</th><th>Producto</th><th>Descripcion</th><th style={{textAlign:'right'}}>Cantidad</th><th style={{textAlign:'right'}}>Precio</th><th style={{textAlign:'right'}}>Total</th></tr></thead>
                                    <tbody>
                                        {(!remisionVer.detalles || remisionVer.detalles.length === 0) ? (
                                            <tr><td colSpan="6" className="sin-datos">Sin items</td></tr>
                                        ) : remisionVer.detalles.map((d, i) => (
                                            <tr key={i}>
                                                <td>{d.item}</td>
                                                <td>{d.idProducto}</td>
                                                <td>{d.descripcionProducto}</td>
                                                <td style={{textAlign:'right'}}>{formatearNumero(d.cantidad, 2)}</td>
                                                <td style={{textAlign:'right'}}>{formatearNumero(d.precio, 2)}</td>
                                                <td style={{textAlign:'right'}}>{formatearNumero((Number(d.cantidad) || 0) * (Number(d.precio) || 0), 2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="modal-footer" style={{ marginTop: '15px' }}>
                                <button className="btn btn-guardar" onClick={() => { setModalVerAbierto(false); setRemisionVer(null); }}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal crear */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido-grande" style={{ maxWidth: '1100px' }}>
                        <div className="modal-header">
                            <h3>Nueva Remision</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                {/* Cabecera */}
                                <div className="form-section">
                                    <h3>Datos de Cabecera</h3>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '15px' }}>
                                        <div className="form-group">
                                            <label>Fecha *</label>
                                            <input type="date" name="fecha" value={formulario.fecha} onChange={handleChangeFormulario} className="form-input" required />
                                        </div>
                                        {/* Sucursal */}
                                        <div className="form-group">
                                            <label>Sucursal *</label>
                                            <div className="cuenta-selector" ref={dropdownSucursalRef}>
                                                <input
                                                    type="text"
                                                    value={formulario.idSucursal ? '' : busquedaSucursal}
                                                    onChange={(e) => { setBusquedaSucursal(e.target.value); setDropdownSucursalAbierto(true); }}
                                                    onFocus={() => setDropdownSucursalAbierto(true)}
                                                    placeholder="Buscar sucursal..."
                                                    className="form-input"
                                                />
                                                {formulario.idSucursal && (
                                                    <div className="cuenta-seleccionada">
                                                        <span className="cuenta-numero">{formulario.idSucursal}</span>
                                                        <span className="cuenta-descripcion">({obtenerNombreSucursal(formulario.idSucursal)})</span>
                                                        <button type="button" onClick={limpiarSucursal} className="btn-clear-cuenta">✖</button>
                                                    </div>
                                                )}
                                                {dropdownSucursalAbierto && (
                                                    <div className="cuenta-dropdown">
                                                        {filtrarSucursales(busquedaSucursal).length === 0 ? (
                                                            <div className="cuenta-item-vacio">No se encontraron sucursales</div>
                                                        ) : (
                                                            filtrarSucursales(busquedaSucursal).slice(0, 50).map(sucursal => (
                                                                <div key={sucursal.idSucursal} onClick={() => seleccionarSucursal(sucursal)} className="cuenta-item">
                                                                    <span className="cuenta-descripcion">{sucursal.nombre}</span>
                                                                    <span className="cuenta-numero">({sucursal.idSucursal})</span>
                                                                </div>
                                                            ))
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {/* Boca */}
                                        <div className="form-group">
                                            <label>Boca *</label>
                                            <div className="cuenta-selector" ref={dropdownBocaRef}>
                                                    <input
                                                        type="text"
                                                        value={formulario.boca ? '' : busquedaBoca}
                                                        onChange={(e) => { setBusquedaBoca(e.target.value); setDropdownBocaAbierto(true); }}
                                                        onFocus={() => setDropdownBocaAbierto(true)}
                                                        placeholder={bocasDisponibles.length === 0 ? 'Seleccione sucursal...' : 'Seleccionar boca...'}
                                                        className="form-input"
                                                        disabled={bocasDisponibles.length === 0}
                                                    />
                                                    {formulario.boca && (
                                                        <div className="cuenta-seleccionada">
                                                            <span className="cuenta-numero">Boca {formulario.boca}</span>
                                                            <button type="button" onClick={limpiarBoca} className="btn-clear-cuenta">✖</button>
                                                        </div>
                                                    )}
                                                    {dropdownBocaAbierto && bocasDisponibles.length > 0 && (
                                                        <div className="cuenta-dropdown">
                                                            {filtrarBocas(busquedaBoca).length === 0 ? (
                                                                <div className="cuenta-item-vacio">No se encontraron bocas</div>
                                                            ) : (
                                                                filtrarBocas(busquedaBoca).map(bocaItem => (
                                                                    <div key={bocaItem.boca} onClick={() => seleccionarBoca(bocaItem)} className="cuenta-item">
                                                                        <span className="cuenta-descripcion">Boca {bocaItem.boca}</span>
                                                                        <span className="cuenta-numero">({bocaItem.cantTimbrados} timbrado{bocaItem.cantTimbrados > 1 ? 's' : ''})</span>
                                                                    </div>
                                                                ))
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                        </div>
                                        {/* Timbrado */}
                                        <div className="form-group">
                                            <label>Timbrado *</label>
                                            <div className="cuenta-selector" ref={dropdownTimbradoRef}>
                                                    <input
                                                        type="text"
                                                        value={formulario.timbrado ? '' : busquedaTimbrado}
                                                        onChange={(e) => { setBusquedaTimbrado(e.target.value); setDropdownTimbradoAbierto(true); }}
                                                        onFocus={() => setDropdownTimbradoAbierto(true)}
                                                        placeholder={!formulario.boca ? 'Seleccione boca...' : 'Seleccionar timbrado...'}
                                                        className="form-input"
                                                        disabled={!formulario.boca || timbradosDisponibles.length === 0}
                                                    />
                                                    {formulario.timbrado && (
                                                        <div className="cuenta-seleccionada">
                                                            <span className="cuenta-numero">{formulario.timbrado}</span>
                                                            {timbradosDisponibles.find(t => t.timbrado === formulario.timbrado) && (
                                                                <span className="cuenta-descripcion">
                                                                    (Vence: {formatearFechaDisplay(timbradosDisponibles.find(t => t.timbrado === formulario.timbrado)?.vencTimbrado)})
                                                                </span>
                                                            )}
                                                            <button type="button" onClick={limpiarTimbrado} className="btn-clear-cuenta">✖</button>
                                                        </div>
                                                    )}
                                                    {dropdownTimbradoAbierto && timbradosDisponibles.length > 0 && (
                                                        <div className="cuenta-dropdown">
                                                            {filtrarTimbrados(busquedaTimbrado).length === 0 ? (
                                                                <div className="cuenta-item-vacio">No se encontraron timbrados</div>
                                                            ) : (
                                                                filtrarTimbrados(busquedaTimbrado).map(frango => (
                                                                    <div key={frango.timbrado} onClick={() => seleccionarTimbrado(frango)} className="cuenta-item">
                                                                        <span className="cuenta-descripcion">{frango.timbrado}</span>
                                                                        <span className="cuenta-numero">(Rango: {frango.desde}-{frango.hasta} | Ult: {frango.ultValor} | Vence: {formatearFechaDisplay(frango.vencTimbrado)})</span>
                                                                    </div>
                                                                ))
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                        </div>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '10px' }}>
                                        <div className="form-group">
                                            <label>Fecha Fin</label>
                                            <input type="date" name="fechafin" value={formulario.fechafin} onChange={handleChangeFormulario} className="form-input" />
                                        </div>
                                        <div className="form-group">
                                            <label>Deposito *</label>
                                            <select
                                                name="idDeposito"
                                                value={formulario.idDeposito}
                                                onChange={handleChangeFormulario}
                                                className="form-input"
                                                disabled={!formulario.idSucursal}
                                            >
                                                <option value="">{!formulario.idSucursal ? 'Seleccione sucursal...' : 'Seleccionar deposito...'}</option>
                                                {depositosFiltrados.map(d => (
                                                    <option key={d.idDeposito} value={d.idDeposito}>
                                                        {d.idDeposito} - {d.nomDepto}{d.reserva === 'S' ? ' (Reserva)' : ''}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Cliente */}
                                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '15px', marginTop: '10px' }}>
                                        <div className="form-group">
                                            <label>Cliente *</label>
                                            <div className="cuenta-selector" ref={dropdownClienteRef}>
                                                <input
                                                    type="text"
                                                    value={formulario.idCliente ? '' : busquedaCliente}
                                                    onChange={(e) => { setBusquedaCliente(e.target.value); setDropdownClienteAbierto(true); }}
                                                    onFocus={() => setDropdownClienteAbierto(true)}
                                                    placeholder="Buscar cliente..."
                                                    className="form-input"
                                                />
                                                {formulario.idCliente && (
                                                    <div className="cuenta-seleccionada">
                                                        <span className="cuenta-numero">{formulario.idCliente}</span>
                                                        <span className="cuenta-descripcion">{formulario.nomCliente} - RUC: {formulario.rucCliente}</span>
                                                        <button type="button" onClick={limpiarCliente} className="btn-clear-cuenta">✖</button>
                                                    </div>
                                                )}
                                                {dropdownClienteAbierto && (
                                                    <div className="cuenta-dropdown">
                                                        {filtrarClientes(busquedaCliente).length === 0 ? (
                                                            <div className="cuenta-item-vacio">No se encontraron clientes</div>
                                                        ) : (
                                                            filtrarClientes(busquedaCliente).map(cli => (
                                                                <div key={cli.idCliente} onClick={() => seleccionarCliente(cli)} className="cuenta-item">
                                                                    <span className="cuenta-numero">[{cli.idCliente}]</span>
                                                                    <span className="cuenta-descripcion">{cli.nomCliente} - {cli.rucCliente}</span>
                                                                </div>
                                                            ))
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label>RUC Cliente</label>
                                            <input type="text" name="rucCliente" value={formulario.rucCliente} className="form-input" readOnly />
                                        </div>
                                        <div className="form-group">
                                            <label>Tel. Cliente</label>
                                            <input type="text" name="telCliente" value={formulario.telCliente} onChange={handleChangeFormulario} className="form-input" />
                                        </div>
                                    </div>

                                    {/* Transporte */}
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '15px', marginTop: '10px' }}>
                                        <div className="form-group">
                                            <label>Dir. Partida</label>
                                            <input type="text" name="dirPartida" value={formulario.dirPartida} onChange={handleChangeFormulario} className="form-input" maxLength="60" />
                                        </div>
                                        <div className="form-group">
                                            <label>Dir. Llegada</label>
                                            <input type="text" name="dirLlegada" value={formulario.dirLlegada} onChange={handleChangeFormulario} className="form-input" maxLength="60" />
                                        </div>
                                        <div className="form-group">
                                            <label>Marca Vehiculo</label>
                                            <input type="text" name="marcaVehiculo" value={formulario.marcaVehiculo} onChange={handleChangeFormulario} className="form-input" maxLength="30" />
                                        </div>
                                        <div className="form-group">
                                            <label>Chapa</label>
                                            <input type="text" name="chapa" value={formulario.chapa} onChange={handleChangeFormulario} className="form-input" maxLength="7" />
                                        </div>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '15px', marginTop: '10px' }}>
                                        <div className="form-group">
                                            <label>Transportista</label>
                                            <input type="text" name="nomTransportista" value={formulario.nomTransportista} onChange={handleChangeFormulario} className="form-input" maxLength="60" />
                                        </div>
                                        <div className="form-group">
                                            <label>RUC Transp.</label>
                                            <input type="text" name="rucTransportista" value={formulario.rucTransportista} onChange={handleChangeFormulario} className="form-input" maxLength="12" />
                                        </div>
                                        <div className="form-group">
                                            <label>Conductor</label>
                                            <input type="text" name="nomConductor" value={formulario.nomConductor} onChange={handleChangeFormulario} className="form-input" maxLength="60" />
                                        </div>
                                        <div className="form-group">
                                            <label>CI Conductor</label>
                                            <input type="text" name="ciConductor" value={formulario.ciConductor} onChange={handleChangeFormulario} className="form-input" />
                                        </div>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '15px', marginTop: '10px' }}>
                                        <div className="form-group">
                                            <label>Motivo *</label>
                                            <div className="cuenta-selector" ref={dropdownMotivoRef}>
                                                <input
                                                    type="text"
                                                    value={formulario.idMotivo ? '' : busquedaMotivo}
                                                    onChange={(e) => { setBusquedaMotivo(e.target.value); setDropdownMotivoAbierto(true); }}
                                                    onFocus={() => setDropdownMotivoAbierto(true)}
                                                    placeholder="Buscar motivo..."
                                                    className="form-input"
                                                />
                                                {formulario.idMotivo && (
                                                    <div className="cuenta-seleccionada">
                                                        <span className="cuenta-numero">{formulario.idMotivo}</span>
                                                        <span className="cuenta-descripcion">({obtenerNombreMotivo(formulario.idMotivo)})</span>
                                                        <button type="button" onClick={limpiarMotivo} className="btn-clear-cuenta">✖</button>
                                                    </div>
                                                )}
                                                {dropdownMotivoAbierto && (
                                                    <div className="cuenta-dropdown">
                                                        {filtrarMotivos(busquedaMotivo).length === 0 ? (
                                                            <div className="cuenta-item-vacio">No se encontraron motivos</div>
                                                        ) : (
                                                            filtrarMotivos(busquedaMotivo).map(motivo => (
                                                                <div key={motivo.idMotivo} onClick={() => seleccionarMotivo(motivo)} className="cuenta-item">
                                                                    <span className="cuenta-numero">[{motivo.idMotivo}]</span>
                                                                    <span className="cuenta-descripcion">{motivo.nomMotivo}</span>
                                                                </div>
                                                            ))
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label>Observaciones</label>
                                            <input type="text" name="obs" value={formulario.obs} onChange={handleChangeFormulario} className="form-input" maxLength="100" />
                                        </div>
                                    </div>
                                </div>

                                {/* Detalles */}
                                <div className="form-section" style={{ marginTop: '20px' }}>
                                    <h3>Detalle de Productos</h3>

                                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr auto', gap: '10px', alignItems: 'end' }}>
                                        <div className="form-group">
                                            <label>Producto *</label>
                                            <div className="cuenta-selector" ref={dropdownProductoRef}>
                                                <input
                                                    type="text"
                                                    value={detalleTemp.idProducto ? '' : busquedaProducto}
                                                    onChange={(e) => { setBusquedaProducto(e.target.value); setDropdownProductoAbierto(true); }}
                                                    onFocus={() => setDropdownProductoAbierto(true)}
                                                    placeholder="Buscar producto..."
                                                    className="form-input"
                                                />
                                                {detalleTemp.idProducto && (
                                                    <div className="cuenta-seleccionada">
                                                        <span className="cuenta-numero">{detalleTemp.idProducto}</span>
                                                        <span className="cuenta-descripcion">({obtenerDescripcionProducto(detalleTemp.idProducto)})</span>
                                                        <button type="button" onClick={limpiarProducto} className="btn-clear-cuenta">✖</button>
                                                    </div>
                                                )}
                                                {dropdownProductoAbierto && (
                                                    <div className="cuenta-dropdown">
                                                        {filtrarProductos(busquedaProducto).length === 0 ? (
                                                            <div className="cuenta-item-vacio">No se encontraron productos</div>
                                                        ) : (
                                                            filtrarProductos(busquedaProducto).map(producto => (
                                                                <div key={producto.idProducto} onClick={() => seleccionarProducto(producto)} className="cuenta-item">
                                                                    <span className="cuenta-descripcion">{producto.descripcion}</span>
                                                                    <span className="cuenta-numero">({producto.idProducto})</span>
                                                                </div>
                                                            ))
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label>Cantidad</label>
                                            <input type="number" name="cantidad" value={detalleTemp.cantidad} onChange={handleChangeDetalleTemp} step="0.001" className="form-input" />
                                        </div>
                                        <div className="form-group">
                                            <button type="button" onClick={agregarDetalle} className="btn btn-nuevo" style={{ marginTop: '5px' }}>
                                                + Agregar
                                            </button>
                                        </div>
                                    </div>

                                    <div style={{ marginTop: '15px' }}>
                                        <table className="tabla-datos" style={{ fontSize: '13px' }}>
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Descripcion</th>
                                                    <th>Cantidad</th>
                                                    <th>Accion</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {detalles.length === 0 ? (
                                                    <tr><td colSpan="4" className="sin-datos">No hay productos agregados</td></tr>
                                                ) : (
                                                    detalles.map((det, index) => (
                                                        <tr key={index}>
                                                            <td>{det.idProducto}</td>
                                                            <td>{obtenerDescripcionProducto(det.idProducto)}</td>
                                                            <td style={{ textAlign: 'right' }}>{formatearNumero(det.cantidad, 3)}</td>
                                                            <td>
                                                                <button type="button" onClick={() => eliminarDetalle(det.idProducto)} className="btn-accion" title="Eliminar">🗑️</button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                                                    <td colSpan="2" style={{ textAlign: 'right' }}>TOTAL ITEMS:</td>
                                                    <td style={{ textAlign: 'right' }}>{detalles.length}</td>
                                                    <td></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <button type="button" onClick={cerrarModal} className="btn-secondary">Cancelar</button>
                                    <button type="submit" className="btn-primary">Guardar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SNRemision;
